/**
 * Live call never connected (busy / no answer). Used for “Missed” badges and icons.
 * Accepts `ActivityLog['callStatus']` from GraphQL or the local `CallStatus` enum (same string values).
 */
export function isMissedCallStatus(
  callStatus: string | null | undefined
): boolean {
  return callStatus === 'NO_ANSWER' || callStatus === 'BUSY'
}
